<template>
    <div class="container-fluid no-gutters mainbg navbar-container">
      <div class="row main">
          <div class="col">
            <bread-crumb />
          </div>

          <div class="col text-right">
            <slot>
              <!-- Slot used for toolbar items on the right of the nav bar -->
            </slot>
          </div>
      </div>
      <div class="row edit-menu-items">
        <div class="col">
          <ul class="edit-menu edit-menu-horizontal">
              <li v-for="(item, index) in editMenuItems" :key="index" class="edit-menu-item edit-menu-item-level-0">
                <a href="javascript:void(0)" v-bind:class="item.cssClass" @click="item.action">
                  {{ item.title }}
                </a>
              </li>
            </ul>
        </div>
      </div>
  </div>
</template>
<script>
import BreadCrumbVue from 'components/BreadCrumb.vue';

export default {
  props: {
    editMenuItems: {
      type: Array
    }
  },
  components: {
    'bread-crumb': BreadCrumbVue
  }
};

export class EditMenuItem {
  constructor (title, action, cssclass) {
    this.title = title;
    this.action = action;
    this.cssClass = cssclass;
  }
}

</script>
<style lang="scss">
.edit-menu-items {
  background: #fff;
}

</style>
